import React from 'react'

const SumoFighterIcon = (props) => {
    return (
        <div
            ref={props.propref}
            id={props.id}
        >
        <svg
        viewBox="0 0 41.612 41.612" 
        {...props}
        className={props.className}
        >
        <g>
            <path 
                d="M35.88,13.611c-0.832-0.629-1.742-1.217-2.707-1.595c-2.18-0.854-4.398-1.611-6.602-2.386
                c-0.521-0.183-0.895-0.782-0.945-1.332c-0.148-1.628-1.012-3.121-2.506-4.154c-0.581-0.402-0.584-0.721-0.298-1.253
                c0.182-0.338,0.35-0.683,0.514-1.027c0.236-0.499,0.102-1.226-0.404-1.449c-1.214-0.536-3.02-0.565-4.263-0.012
                c-0.504,0.225-0.655,0.96-0.439,1.468c0.121,0.284,0.243,0.57,0.366,0.859c0.216,0.508,0.016,1.166-0.402,1.527
                c-1.259,1.087-1.998,2.426-2.116,4.093c-0.039,0.551-0.423,1.141-0.948,1.311c-1.901,0.616-3.782,1.19-5.606,1.908
                c-1.305,0.513-2.624,1.167-3.689,2.055c-0.844,0.704-1.592,1.783-1.88,2.833c-0.376,1.368,0.022,4.278,1.085,6.2
                c0.266,0.484,0.855,0.498,1.218,0.084c0.336-0.385,0.677-0.761,1.068-1.076c1.033-0.833,1.05-1.854,0.708-2.953
                c-0.105-0.338-0.256-0.661-0.428-1.009c-0.245-0.495-0.075-0.875,0.376-0.844c0.289,0.019,0.554,0.034,0.818,0.033
                c0.83-0.004,1.985-0.382,2.405,0.021c0.499,0.478,0.439,1.613,0.473,2.469c0.017,0.427-0.181,0.99-0.483,1.281
                c-1.127,1.083-2.376,2.039-3.509,3.115c-1.868,1.778-2.837,3.889-1.948,6.491c0.765,2.24,1.594,4.459,2.436,6.672
                c0.829,2.179,0.483,3.029-1.709,3.993c-0.082,0.036-0.156,0.094-0.239,0.161c-0.123,0.101-0.134,0.248-0.028,0.336
                c0.084,0.069,0.151,0.122,0.214,0.118c1.777-0.127,3.56-0.217,5.323-0.452c0.505-0.067,0.955-0.455,0.379-1.196
                c-0.39-0.503-0.622-1.273-0.605-1.916c0.05-1.889,0.314-3.771,0.378-5.66c0.013-0.392-0.054-0.785-0.138-1.158
                c-0.121-0.538,0.191-1.139,0.705-1.342c1.213-0.479,2.405-0.951,3.628-1.435c0.514-0.203,0.857,0.074,0.768,0.619
                c-0.082,0.499-0.163,0.991-0.247,1.483c-0.234,1.369,0.399,2.272,1.617,2.279c3.095,0.018,6.045-0.677,8.603-2.4
                c0.791-0.532,1.486-0.676,2.155-0.604c0.549,0.06,0.969,0.687,0.964,1.239c-0.01,1.14-0.029,2.246,0.018,3.349
                c0.074,1.796,0.642,3.634-0.295,5.429c-0.254,0.49-0.219,1.002,0.19,1.217c0.269,0.141,0.519,0.255,0.778,0.287
                c1.365,0.172,2.744,0.237,4.119,0.322c0.133,0.008,0.269-0.008,0.403-0.029c0.22-0.037,0.414-0.141,0.433-0.228
                c0.02-0.088-0.125-0.239-0.323-0.34c-0.119-0.06-0.239-0.119-0.361-0.173c-1.7-0.745-2.164-1.865-1.489-3.578
                c0.641-1.622,1.398-3.212,1.867-4.883c0.454-1.621,1.029-3.389,0.797-4.983c-0.358-2.457-2.264-3.922-4.093-5.461
                c-0.423-0.356-0.871-0.218-1.044,0.306c-2.25,6.805-7.771,9.02-11.91,8.984c-0.552-0.005-0.953-0.482-0.895-1.012
                c0.036-0.32,0.08-0.639,0.154-0.949c0.184-0.768-0.093-1.109-0.759-1.532c-1.186-0.753-2.364-1.608-3.296-2.646
                c-0.828-0.92-1.654-1.91-2.002-3.178c-0.146-0.534,0.108-0.628,0.467-0.209c2.607,3.04,5.866,4.681,9.871,3.292
                c3.541-1.229,6.985-2.99,7.739-7.151c0.1-0.543,0.572-0.992,1.125-0.992c0.624,0,1.227,0,1.792,0c0.552,0,0.901,0.437,0.742,0.966
                c-0.296,0.973-0.636,1.943-0.396,2.739c0.26,0.864,1.096,1.554,1.907,2.302c0.406,0.374,0.935,0.311,1.16-0.193
                c0.668-1.489,0.94-2.929,1.11-4.426C37.969,16.299,37.396,14.757,35.88,13.611z M20.811,12.178
                c-1.928-0.008-3.201-1.422-3.185-3.537c0.018-2.246,1.53-4.126,3.282-4.079c1.713,0.046,3.11,1.898,3.11,4.124
                C24.018,10.828,22.771,12.186,20.811,12.178z"
            />
        </g>
        </svg>
        </div>
    )
}

export default SumoFighterIcon
